import {ref} from "vue";
import axios from "axios";

export default function useQuote() {
    axios.defaults.baseURL = '/api/v1.0/'

    const errors = ref([])

    const validateResponse = (response) => {
        if (response.status === 422) {
            for (let error in response.data.errors) {
                errors.value[error] = response.data.errors[error][0]
            }
        }
    }

    const requestXoperoOnePricing = async (params) => {
        errors.value = []

        try {
            await axios.post('xopero-one-pricing/quote-request', params)
        } catch (e) {
            validateResponse(e.response)
        }
    }

    return {
        errors,
        requestXoperoOnePricing
    }
}
